import type { FC } from "react";

import { CustomSlider, DefaultImage } from "@/components/atoms";
import { cn } from "@/lib/utils";

interface ImageInProcessProps {
  value: number;
  classes?: string;
}

const ImageInProcess: FC<ImageInProcessProps> = ({ value, classes }) => {
  return (
    <DefaultImage classes={cn("w-[106px] h-[106px] relative", classes)}>
      <CustomSlider
        value={[value]}
        max={100}
        step={1}
        className="absolute bottom-[9px] left-[10px] w-[82%] z-40"
      />
    </DefaultImage>
  );
};

export default ImageInProcess;
